/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import TextareaAutosize from 'react-autosize-textarea'
import classNames from 'classnames/bind'
import Icon from 'elements/Icon'
import * as styles from './Textarea.scss'

const cx = classNames.bind(styles)

interface IProps {
  styleType?: string,
  size: 'medium' | 'large',
  iconName?: string,
  state?: string,
}

const Textarea: React.SFC<IProps> = ({
  styleType = 'default',
  size = 'medium',
  iconName,
  state,
  ...restProps
}) => (
  <div className={cx('root', styleType, size, state)}>
    <TextareaAutosize {...restProps} className={cx('input', styleType, size, state)} />
    {(restProps.showLengthCounter && restProps.maxLength) && (
      <div className={styles.counter}>{restProps.value.length}/{restProps.maxLength}</div>
    )}
    <div className={styles.icon}>
      <Icon name={iconName} size={size} />
    </div>
  </div>
)

export default Textarea
